import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from "./pages/App";
import i18next from "./translations";
import {I18nextProvider} from "react-i18next";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
      <I18nextProvider i18n={i18next}>
          <App />
      </I18nextProvider>
  </React.StrictMode>
);

